module.exports = __webpack_public_path__ + "assets/media/mini_edit_category_icon.c157a77f.svg";